export function deliveryFeeFor(fulfilment, subtotal) {
  return fulfilment === "delivery" && subtotal < 799 ? 40 : 0;
}

export function loyaltyDiscountFor({ items, menuItems, redeem, readyRedemptions }) {
  if (!redeem || readyRedemptions < 1) return 0;
  const romanIds = new Set(menuItems.filter((item) => item.category === "roman").map((item) => item.id));
  return items.filter((item) => romanIds.has(item.item_id)).reduce((max, item) => Math.max(max, item.unit_price), 0);
}

export function checkoutTotal(subtotal, deliveryFee, loyaltyDiscount) {
  return Math.max(0, subtotal + deliveryFee - loyaltyDiscount);
}